module.exports = __webpack_public_path__ + "img/icon_service_4.88ef4749.jpg";